import { render, staticRenderFns } from "./digitalFlop.vue?vue&type=template&id=ff2616c0&scoped=true"
import script from "./digitalFlop.vue?vue&type=script&lang=js"
export * from "./digitalFlop.vue?vue&type=script&lang=js"
import style0 from "./digitalFlop.vue?vue&type=style&index=0&id=ff2616c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2616c0",
  null
  
)

export default component.exports